var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBxBxsFolderOpen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.165 19.551C2.351 19.831 2.664 20 3 20H18C18.4 20 18.762 19.762 18.919 19.394L21.919 12.394C21.9847 12.2419 22.0116 12.0759 21.9971 11.9109C21.9827 11.7458 21.9273 11.587 21.8362 11.4487C21.745 11.3104 21.6208 11.1969 21.4748 11.1186C21.3288 11.0403 21.1657 10.9995 21 11H20V8C20 6.897 19.103 6 18 6H11.345L8.789 4H4C2.897 4 2 4.897 2 6V19H2.007C2.00477 19.1951 2.05969 19.3867 2.165 19.551ZM18 8V11H6C5.6 11 5.238 11.238 5.081 11.606L4 14.129V8H18Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxBxsFolderOpen);
export default __webpack_public_path__ + "static/media/bxBxsFolderOpen.73d0068451707187893acaf4adb2cba8.svg";
export { ForwardRef as ReactComponent };